import {
  FaBuilding,
  FaUsers,
  FaImage,
  FaSlidersH,
  FaColumns,
  FaUserCog,
  FaEnvelope,
  FaThumbsUp,
  FaDatabase,
  FaUsersCog
} from 'react-icons/fa'
import { PageMenu } from 'components/ideal-core-ui'

const MENU = [
  {
    key: 'details',
    icon: <FaBuilding />,
    text: 'Organization Details'
  },
  {
    key: 'users',
    icon: <FaUsers />,
    text: 'Users & Teams'
  },
  {
    key: 'templates',
    icon: <FaImage />,
    text: 'Branding & Templates'
  },
  {
    key: 'currency',
    icon: <FaSlidersH />,
    text: 'Currency, Date Format'
  },
  {
    key: 'timeTracker',
    icon: <FaUsersCog />,
    text: 'Time Tracker Module'
  },
  {
    key: 'leads',
    icon: <FaUsersCog />,
    text: 'Leads Module'
  },
  {
    key: 'opportunity',
    icon: <FaUserCog />,
    text: 'Opportunity Settings'
  },
  {
    key: 'company',
    icon: <FaBuilding />,
    text: 'Client/Company Settings'
  },
  {
    key: 'contact',
    icon: <FaUsersCog />,
    text: 'Contact Settings'
  },
  {
    key: 'email',
    icon: <FaEnvelope />,
    text: 'Organization Email Settings'
  },
  {
    key: 'imports',
    icon: <FaDatabase />,
    text: 'Data Imports'
  },
  {
    key: 'exports',
    icon: <FaDatabase />,
    text: 'Data Exports'
  },
  {
    key: 'pipeline',
    icon: <FaColumns />,
    text: 'Pipeline Stages'
  },
  {
    key: 'subscription',
    icon: <FaThumbsUp />,
    text: 'Subscription Plans'
  }
]

const Menu = ({ page, setPage }) => {
  return <PageMenu page={page} setPage={setPage} menu={MENU} withUpdateUrl />
}

export default Menu
